import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useTranslation } from "react-i18next";

function TitleSelector() {
  const { t } = useTranslation();

  const titles = {
    "/dashboards/dataquality": {
      title: "Data Quality",
      subText: t("navbar.titleSubtext.dataQuality"),
    },
    "/trafficmonitoring/monitoring": {
      title: "Traffic Monitoring",
      subText: t("navbar.titleSubtext.trafficMonitoring"),
    },
    "/trafficmonitoring/historical_monitoring": {
      title: "Historical",
      subText: t("navbar.titleSubtext.historicalMonitoring"),
    },
    "/dashboards/mfd": {
      title: "MFD",
      subText: t("navbar.titleSubtext.mfd"),
    },
    "/dashboards/routeFlows": {
      title: "Route Flows",
      subText: t("navbar.titleSubtext.routeFlows"),
    },
    "/dashboards/intersection": {
      title: "Intersection",
      subText: t("navbar.titleSubtext.intersection"),
    },
    "/dashboards/detectorslist": {
      title: "Data Quality Detectors List",
      subText: t("navbar.titleSubtext.detectorsList"),
    },
    "/notifications/create": {
      title: "Create Alert",
      subText: t("navbar.titleSubtext.createAlert"),
    },
    "/notifications/show": {
      title: "Alerts List",
      subText: t("navbar.titleSubtext.alertsList"),
    },
    "/trajectories": {
      title: "Trajectories analytics",
      subText: t("trajectories.subtitle"),
    },
    "/events/create": {
      title: "Event Management",
      subText: t("navbar.titleSubtext.eventsCreate"),
    },
    "/events/show": {
      title: "Event Management",
      subText: t("navbar.titleSubtext.eventsShow"),
    },
    "/sumo/create": {
      title: "SUMO",
      subText: t("navbar.titleSubtext.sumoCreate"),
    },
    "/sumo/show": {
      title: "SUMO List",
      subText: t("navbar.titleSubtext.sumoShow"),
    },
    "/bottlenecks": {
      title: "Identification of Bottlenecks",
      subText: t("navbar.titleSubtext.bottlenecks"),
    },
    "/createScenario": {
      title: "Create Scenario",
      subText: "",
    },
    "/scenariosLibrary": {
      title: "Scenarios Library",
      subText: "",
    },
    "/scenariosSimulated": {
      title: "Simulated Scenarios",
      subText: "",
    },
        "/ScenariosLogs": {
      title: "Scenarios Logs",
      subText: "",
    },
        "/tmpxLogs": {
      title: "TMPX Logs",
      subText: "",
    },
  };

  const location = useLocation();
  useEffect(() => {}, [location.pathname]);
  return (
    <MDBox p={3} lineHeight={1}>
      <MDTypography variant="h5" fontWeight="medium">
        {titles[location.pathname]?.title || ""}
      </MDTypography>
      <MDTypography variant="button" color="text">
        {titles[location.pathname]?.subText || ""}
      </MDTypography>
    </MDBox>
  );
}

export default TitleSelector;
